import styled from "styled-components/macro";

export const ActionFooter = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "36px",
  marginTop: "20px",
  width: "100%",

  div: {
    alignSelf: "center",
  },

  [theme.breakpoint.lg()]: {
    button: {
      alignSelf: "flex-start",
    },
    div: {
      alignSelf: "flex-start",
    },
  },
}));
